import { useState } from "react";

const money = (n) => `$${(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export function PaymentReconciliation({ data }) {
  const [open, setOpen] = useState(false);
  if (!data) return null;
  return (
    <div className="bg-white rounded-xl border border-zinc-200 p-4 space-y-2" data-testid="paid-reconciliation">
      <div className="flex flex-wrap items-baseline gap-x-6 gap-y-1">
        <span className="text-xs text-zinc-500 uppercase tracking-wide">Payments reconciliation</span>
        <span className="text-sm" data-testid="recon-linked">
          <strong>{money(data.linked_revenue)}</strong> of {money(data.total_payments)} paid in this period is linked to an estimate
          {" "}(<strong>{data.linked_pct}%</strong>, {data.linked_invoices} of {data.payments_in_period} invoices)
        </span>
        {data.unmatched_invoices_count > 0 && (
          <button className="text-xs text-[#207024] font-medium underline" onClick={() => setOpen(!open)} data-testid="recon-toggle-unmatched">
            {open ? "Hide" : "Show"} {data.unmatched_invoices_count} unmatched ({money(data.unmatched_revenue)})
          </button>
        )}
      </div>
      {open && (
        <div className="max-h-72 overflow-y-auto border-t border-zinc-100" data-testid="recon-unmatched-list">
          <table className="w-full text-xs">
            <tbody>
              {data.unmatched_invoices.map((i) => (
                <tr key={i.invoice_id} className="border-b border-zinc-50">
                  <td className="py-1.5 pr-3 truncate max-w-[220px]">{i.invoice_number || i.invoice_id}</td>
                  <td className="py-1.5 pr-3">{i.customer_name}</td>
                  <td className="py-1.5 pr-3 whitespace-nowrap">{new Date(i.paid_at).toLocaleDateString()}</td>
                  <td className="py-1.5 text-right font-medium">{money(i.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
